import Link from 'next/link'
/* eslint tailwindcss/no-custom-classname: off */
export const Logo: React.FC = () => {
  return (
    <Link href="/">
      <div className="logo link"></div>
    </Link>
  )
}
